import React, { Fragment } from "react";
import {
  Container,
  Paper,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Box,
  Typography
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import swal from "sweetalert";
import * as dataApi from "../../api/dataApi";

class ValidateDataImportResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() - 1,
      utl: false,
      org: 1,
      open: false,
      records: [],
      response: {},
      hideRecords: true,
      saksnr: 0,
      transactions: [],
      hideTransactions: true,
      hideSpecs: true,
    };
  }

  async componentDidMount() {
    try {
      this.getRecords();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  toggleRecords = () => {
    this.setState((prevState) => ({
      hideRecords: !prevState.hideRecords,
      hideTransactions: true,
    }));
  };

  toggleSpecs = () => {
    this.setState((prevState) => ({
      hideSpecs: !prevState.hideSpecs,
    }));
  };

  getTransactions = async () => {
    const transactions = await dataApi.dataImportResultTransactions(this.state.saksnr);
    this.setState({
      transactions: transactions || [],
      hideRecords: true,
      hideTransactions: transactions ? false : true,
    });
  };

  getRecords = async () => {
    const records = await dataApi.dataImportResultOverview();
    this.setState({ records: records || [] });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileChange = (acceptedFiles) => {
    this.setState({ files: acceptedFiles });
  };

  handleUpload = async () => {
    const { files, year, month, org, utl } = this.state;

    if (files.length) {
      const response = await dataApi.validateDataImportResult(files, year, month, org, utl);
      if (response) {
        if (response.status === "Success") {
          swal({
            title: "Opplastingen er vellykket!",
            icon: "success",
          });
        } else if (response.status === "Fail") {
          this.setState({
            open: true,
            response,
          });
        }
      } else {
        swal({
          title: "Opplastingen er mislykket!",
          text: "Teknisk feil. Kontakt administrator.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
      toast.error("Velg en fil..");
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { year, month, org, utl, hideSpecs, hideRecords, hideTransactions, saksnr } = this.state;
    const months = Array.from({ length: 12 }, (_, i) => i + 1);

    const styles = {
      layout: { width: "90%", paddingTop: 100, margin: "auto" },
      root: { width: "100%" },
      button: { marginTop: 30, marginBottom: 20 },
      formControl: { padding: "10px", minWidth: "70%", marginLeft: 20 },
      tableHeader: { backgroundColor: "#eeeeee", fontWeight: "bold", fontSize: 14 },
      tableHeaderDark: { backgroundColor: "#e6e6e6", fontWeight: "bold", fontSize: 16 },
    };

    return (
      <Container maxWidth="xl">
        <main style={styles.layout}>
          <Paper style={styles.root}>
            <Grid container spacing={2} style={{ padding: 20 }}>
              <Grid item lg={12}>
                <h2>Opplasting av rapport for kontroll og sammenligning av skadedata importert fra TIA</h2>
                <p>
                  Dette er en ny funksjon som tar imot skadedatarapporten og sammenligner den med dataene som er importert fra TIA.
                  NB! Viktig at måned, år og org passer med filen.
                </p>
                <p>Prossesering og sammenlikning tar opptil 6 minutter!</p>
                <Button variant="contained" color="primary" size="small" onClick={this.toggleSpecs}>
                  Vis Krav til kolonner i rapportfil
                </Button>
                {!hideSpecs && (
                  <ul>
                    <li><strong>A:</strong> Skadenummer (heltall)</li>
                    <li><strong>B:</strong> AnmeldtDato (datoformat)</li>
                    <li><strong>C:</strong> SkadeDato (datoformat)</li>
                    <li><strong>D:</strong> Produkt</li>
                    <li><strong>G:</strong> Reserve (heltall)</li>
                    <li><strong>H:</strong> Utbetalt (heltall)</li>
                    <li><strong>I:</strong> Innbetalt (heltall)</li>
                    <li><strong>N:</strong> Status (tekst)</li>
                    <li><strong>O:</strong> Dato for siste oppdatering</li>
                  </ul>
                )}
              </Grid>

              <Grid item lg={12}>

                <Grid container spacing={2} alignItems="center" sx={{ display: "flex" }}>
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>År</InputLabel>
                      <Select name="year" value={year} onChange={this.handleChange}>
                        <MenuItem value={year}>{year}</MenuItem>
                        <MenuItem value={year - 1}>{year - 1}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>Måned</InputLabel>
                      <Select name="month" value={month} onChange={this.handleChange}>
                        {months.map((value) => (
                          <MenuItem key={value} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>Org</InputLabel>
                      <Select name="org" value={org} onChange={this.handleChange}>
                        <MenuItem value={1}>TFF</MenuItem>
                        <MenuItem value={2}>YFF</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>UTL</InputLabel>
                      <Select name="utl" value={utl} onChange={this.handleChange} disabled={true}>
                        <MenuItem value={false}>Nei</MenuItem>
                        <MenuItem value={true}>Ja</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid item lg={12} style={{ paddingTop: 20 }}>
                  <Dropzone onDrop={this.handleFileChange} />
                </Grid>

                <Grid item lg={12} style={{ marginTop: 30, marginBottom: 20 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<CloudDownloadIcon />}
                    onClick={this.handleUpload}
                  >
                    Last opp
                  </Button>
                </Grid>

                <Grid item lg={12}>
                  <Button variant="contained" color="primary" size="small" onClick={this.toggleRecords}>
                    Importoversikt
                  </Button>
                </Grid>
                <Grid item lg={12} style={{ marginTop: 20 }}>
                  <TextField
                    variant="standard"
                    name="saksnr"
                    label="Saksnummer"
                    value={saksnr || ""}
                    onChange={this.handleChange}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={this.getTransactions}
                    style={{ marginLeft: 10 }}
                  >
                    Søk
                  </Button>
                </Grid>

                <Grid item lg={12} style={{ marginTop: 20 }}>
                  {/* Imported Records Overview */}
                  <div hidden={hideRecords}>
                    <h4>Oversikt</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Transaksjonsdato</th>
                          <th>Antall transaksjoner</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.records.length !== 0
                          ? this.state.records.map((row, index) => {
                            let date = row.transactionDate;
                            date =
                              ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
                              "." +
                              new Date(date).getFullYear();
                            return (
                              <tr key={index}>
                                <td>{date}</td>
                                <td style={{ textAlign: "center" }}>{row.count}</td>
                              </tr>
                            );
                          })
                          : ""}
                      </tbody>
                    </table>
                  </div>

                  {/* Transactions Overview */}
                  <div hidden={hideTransactions}>
                    <h4>Sak</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Dato</th>
                          <th>Kilde</th>
                          <th>Innbetalt</th>
                          <th>Utbetalt</th>
                          <th>Omkostninger</th>
                          <th>Reserve</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.transactions.length !== 0
                          ? this.state.transactions.map((row, index) => {
                            let date = row.transactionDate;
                            date =
                              ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
                              "." +
                              new Date(date).getFullYear();
                            return (
                              <tr key={index}>
                                <td>{date}</td>
                                <td>{row.sourceId}</td>
                                <td>{row.paidIn}</td>
                                <td>{row.paidOut}</td>
                                <td>{row.costs}</td>
                                <td>{row.reserves}</td>
                                <td>{row.statusId}</td>
                              </tr>
                            );
                          })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </Grid>
                <Grid item lg={12}>
                  <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>{`Totalt ${this.state.response.totalRowsOfData} rader. ${this.state.response.comment}`}</DialogTitle>
                    <DialogContent>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={styles.tableHeaderDark}>Rad</TableCell>
                              <TableCell style={styles.tableHeaderDark}>Saksnr.</TableCell>
                              <TableCell style={styles.tableHeader}>Feltnr</TableCell>
                              <TableCell style={styles.tableHeader}>Navn</TableCell>
                              <TableCell style={styles.tableHeader}>Feilmelding</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Object.keys(this.state.response).length !== 0 ? (this.state.response.failedRows.map((row) => (
                              <TableRow key={row.rowNr}>
                                <TableCell>{row.rowNr}</TableCell>
                                <TableCell>{row.comment}</TableCell>
                                {Object.keys(row.fieldErrors).length !== 0 ? (row.fieldErrors.map((error) => (
                                  <Fragment>
                                    <TableRow>
                                      <TableCell>{error.fieldNr}</TableCell>
                                      <TableCell>{error.fieldName}</TableCell>
                                      <TableCell>{error.errorMessage}</TableCell>
                                    </TableRow>
                                  </Fragment>
                                ))) : (
                                  <Fragment>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                  </Fragment>
                                )}
                              </TableRow>
                            ))) : ""}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                        Avbryt
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </Container>
    );
  }
}

function Dropzone({ onDrop }) {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDrop,
    accept: [".xls", ".xlsx"],
    maxFiles: 1,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: "2px dashed #aaa",
        padding: 4,
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body1">
        Dra og slipp en fil her eller klikk for å velge en fil
      </Typography>
      {acceptedFiles.length > 0 && (
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Valgt fil: {acceptedFiles[0].name}
        </Typography>
      )}
    </Box>
  );
}


export default ValidateDataImportResult;
